<template>
  <b-card class="shadowed p-2 h-100" body-class="px-1 px-md-3">
    <div class="d-flex justify-content-center flex-column">
      <div class="d-flex align-items-center">
        <slot name="icon" />
        <h6 :class="[isDisabled ? 'text-disabled' : `text-${titleVariant}`, 'mb-0']">
          {{ title }}
        </h6>
      </div>
      <div>
        <h5 v-if="primaryTitle">{{ primaryTitle }}</h5>
        <p v-html="description" />
        <slot name="extra-body" />
      </div>
    </div>
    <div class="d-flex align-items-center justify-content-end mt-4">
      <b-button
        :variant="secondaryButtonVariant"
        :disabled="isDisabled"
        @click="$emit('secondaryClicked')"
        v-if="secondaryButtonText"
        class="mr-2 font-weight-bold"
        :size="buttonSize"
        >{{ secondaryButtonText }}
      </b-button>
      <b-button
        :variant="buttonVariant"
        :disabled="isDisabled"
        @click="$emit('primaryClicked')"
        :size="buttonSize"
        >{{ buttonText }}
      </b-button>
    </div>
  </b-card>
</template>

<script>
export default {
  name: "ActionableCard",
  props: {
    primaryTitle: String,
    title: String,
    titleVariant: String,
    description: String,
    buttonText: String,
    buttonVariant: String,
    secondaryButtonText: String,
    secondaryButtonVariant: String,
    buttonSize: String,
    isDisabled: Boolean,
  },
};
</script>
